import { render, staticRenderFns } from "./ToolAlign.vue?vue&type=template&id=b6aa0980"
import script from "./ToolAlign.vue?vue&type=script&lang=js"
export * from "./ToolAlign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports